import modelNumeric from './model-numeric'

export default {
  modelNumeric
}
